var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "noticeMessage" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "notice-header" }, [
            _c("span", { staticClass: "notice-title" }, [
              _vm._v("通知消息设置"),
            ]),
          ]),
          _c(
            "el-form",
            {
              staticClass: "notice-form",
              attrs: { model: _vm.form, "label-width": "110px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "通知消息" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.is_open_notice,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "is_open_notice", $$v)
                      },
                      expression: "form.is_open_notice",
                    },
                  }),
                  _c(
                    "span",
                    {
                      class: [
                        "switch-text",
                        _vm.form.is_open_notice ? "is-open" : "is-close",
                      ],
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.form.is_open_notice ? "已开启" : "已关闭"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  !_vm.form.is_open_notice
                    ? _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          " 关闭后，该功能菜单不弹出通知消息，点击「保存」后生效。 "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm.form.is_open_notice
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择消息" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "notice-select",
                          attrs: { placeholder: "请选择", filterable: "" },
                          model: {
                            value: _vm.form.notice_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "notice_id", $$v)
                            },
                            expression: "form.notice_id",
                          },
                        },
                        _vm._l(_vm.noticeOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.title, value: item.id },
                          })
                        }),
                        1
                      ),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          " 仅可选择「通用」或「本公司白名单」中开启、且在有效期内的消息；点击「保存」后生效。 "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.resetForm } }, [
                    _vm._v("取消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.saving,
                        disabled: !_vm.isChanged,
                      },
                      on: { click: _vm.save },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }